import { defaultAxiosInstance } from "./defaultInstance";

/**
 * 어드민 로그인 1단계 (이메일·비밀번호)
 * - OTP 미사용: userInfo 반환
 * - OTP 사용: { otpRequired: true, challengeId, maskedPhone, expiresIn, resendAvailableIn, smsSent } 반환
 */
export const loginAdminWithEmail = async ({ email, password }) => {
  const response = await defaultAxiosInstance.post("/admin/login/email", { email, password });
  return response.data;
};

/**
 * 어드민 로그인 2단계 (SMS 인증번호 확인) - 성공 시 userInfo 반환
 */
export const verifyAdminLoginOtp = async ({ challengeId, code }) => {
  const response = await defaultAxiosInstance.post("/admin/login/otp/verify", { challengeId, code });
  return response.data;
};

/**
 * 어드민 로그인 인증번호 재발송 - { expiresIn, resendAvailableIn, smsSent } 반환
 */
export const resendAdminLoginOtp = async ({ challengeId }) => {
  const response = await defaultAxiosInstance.post("/admin/login/otp/resend", { challengeId });
  return response.data;
};
